import cloneDeep from "lodash/cloneDeep";

export const capitalize = (s) => {
  if (typeof s !== "string") return "";
  return s.charAt(0).toUpperCase() + s.slice(1);
};

export const getInitialReducerState = (initial) => cloneDeep(initial);
